import palette from '../palette';
import shadows from '../shadows';

// Extract contained styles for reuse
const containedStyles = {
  ':disabled': {
    backgroundColor: palette._next.action.disabledBackground,
    boxShadow: 'none',
  },
  ':hover': {
    backgroundColor: palette._next.primary.dark,
    boxShadow: shadows[10], // figma 4
    color: palette._next.primary.contrastText,
  },
  backgroundColor: palette._next.primary.main,
  boxShadow: shadows[9], // figma 2
  color: palette._next.primary.contrastText,
};

const outlinedGreenStyles = {
  ':active': {
    '& .MuiTouchRipple-child': {
      backgroundColor: palette._next.primary._states.focusVisible,
    },
  },
  ':disabled': {
    borderColor: 'transparent',
    color: palette._next.action.disabledBackground,
  },
  ':hover': {
    backgroundColor: palette._next.primary._states.hover,
    borderColor: palette._next.primary._states.outlinedBorder,
    boxShadow: shadows[1],
  },
  border: '1px solid',
  borderColor: palette._next.primary._states.outlinedBorder,
  color: palette._next.primary.dark,
};

const outlinedBlueStyles = {
  ':active': {
    '& .MuiTouchRipple-child': {
      backgroundColor: palette._next.secondary.contrastText,
    },
    backgroundColor: palette._next.secondary._states.focusVisible,
    color: palette._next.secondary.contrastText,
  },
  ':disabled': {
    borderColor: palette._next.action.disabledBackground,
    color: palette._next.action.disabled,
  },
  ':hover': {
    backgroundColor: palette._next.secondary._states.hover,
    borderColor: palette._next.secondary._states.outlinedBorder,
    boxShadow: shadows[1],
    color: palette._next.secondary.dark,
  },

  '[aria-expanded="true"]': {
    backgroundColor: palette._next.secondary._states.focusVisible,
    color: palette._next.secondary.contrastText,
  },
  border: `1px solid ${palette.secondary.main}`,
  borderColor: palette._next.secondary._states.outlinedBorder,
  color: palette._next.secondary.dark,
};

const withIconStyles = {
  '& .MuiButton-startIcon, & .MuiButton-endIcon': {
    marginTop: '-0.3rem',
  },
  lineHeight: 1.2,
  padding: '0.3rem 16px 0',
};

const MuiButton = {
  defaultProps: {
    variant: 'contained',
  },
  styleOverrides: {
    root: {
      ':disabled': {
        color: palette.text.disabled,
      },
      ':hover': {
        boxShadow: shadows[1],
        color: 'inherit',
      },
      '@media max-width(900px)': {
        marginBottom: 0,
        width: '100%',
      },
      borderRadius: 18,
      boxShadow: 'none',
      fontSize: 16,
      height: 32,
      minWidth: 112,
      padding: '2px 24px 0',
      textTransform: 'none',
      whiteSpace: 'nowrap',
    },
  },
  variants: [
    {
      props: { variant: 'contained' },
      style: containedStyles,
    },
    {
      props: { variant: 'vertical-with-icon-contained' },
      style: {
        ...containedStyles,
        ...withIconStyles,
      },
    },
    {
      props: { variant: 'outlined' },
      style: outlinedGreenStyles,
    },
    {
      props: { variant: 'outlined-blue' },
      style: outlinedBlueStyles,
    },
    {
      props: { variant: 'text-blue' },
      style: { ...outlinedBlueStyles, border: 'none', boxShadow: 'none' },
    },
    {
      props: { variant: 'vertical-with-icon-outlined' },
      style: {
        ...outlinedBlueStyles,
        ...withIconStyles,
      },
    },
    {
      props: { variant: 'contained' },
      style: containedStyles,
    },
    {
      props: { variant: 'outlinedError' },
      style: {
        ':disabled': {
          backgroundColor: palette.surface.white,
          border: 'none',
        },
        ':hover': {
          backgroundColor: palette.secondary.light,
          border: `1px solid ${palette.secondary.main}`,
        },
        border: `1px solid ${palette.error.main}`,
        color: palette.error.main,
      },
    },
    {
      props: { variant: 'text' },
      style: {
        ':hover': {
          backgroundColor: palette.secondary.light,
          boxShadow: shadows[1],
        },
        borderRadius: 0,
      },
    },
    {
      props: { variant: '_next.text' },
      style: {
        ':hover': {
          backgroundColor: palette._next.secondary._states.background,
          boxShadow: shadows[1],
          color: palette._next.secondary.main,
        },
        borderRadius: 0,
      },
    },
    {
      props: { fullWidth: true },
      style: {
        width: '100%',
      },
    },
    {
      props: { variant: 'listTab' },
      styles: {
        ':hover': {
          backgroundColor: 'none',
          boxShadow: 'none',
        },
        borderRadius: 0,
      },
    },
    {
      props: { variant: 'dataTable' },
      style: {
        '& > span > svg, & > span > span > svg': {
          marginTop: -4,
        },
        ':hover': {
          backgroundColor: palette._next.secondary.hover,
          boxShadow: shadows[1],
        },
        borderRadius: 0,
        color: palette._next.secondary.main,
        minWidth: 85,
        paddingLeft: 8,
        paddingRight: 8,
      },
    },
  ],
};

export default MuiButton;
